import { useState, useEffect } from "react";
import DSBox from "../../views/system-design/DSBox";
import DSTypography from "../../views/system-design/DSTypography";
import DSSlider from "../../views/system-design/DSSlider";

const SimpleBar = (props: {
  title: string;
  onChange: (e: any) => void;
  max: number;
  default: number;
}) => {
  const [vol, setVol] = useState(props.default);

  useEffect(() => {
    setVol(props.default);
  }, [props.default]);
  return (
    <DSBox
      sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        width: "100%",
        gap: 2,
      }}
    >
      <DSBox sx={{ width: { xxs: "50%", sm: "42%", md: "33%" } }}>
        <DSTypography sx={{ fontWeight: 700, pl: 2.5, pt: 1.5 }}>
          {props.title}
        </DSTypography>
      </DSBox>
      <DSBox sx={{ width: "50%" }}>
        <DSSlider
          min={0}
          max={props.max}
          valueLabelDisplay="auto"
          value={vol}
          onChange={(_, value) => {
            const newValue = Array.isArray(value) ? value[0] : value;
            setVol(newValue);
            props.onChange({ target: { value: String(newValue) } });
          }}
        />
      </DSBox>
    </DSBox>
  );
};

export default SimpleBar;
